import { createContext } from 'react';

export default createContext({ state: null, dispatch: null });
